
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signupEvents, resetEventsState } from "../../../store/reducers/signupEventsSlice";
import "./Events.css";
import Footer from "../Footer";
import Head from "../Head";
import Swal from "sweetalert2";

const Events = () => {
  const dispatch = useDispatch();
  const { loading, error, success, message } = useSelector((state) => state?.signUpEvents);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [isAccepted, setIsAccepted] = useState(false);
  const [errorAcceptance, setErrorAcceptance] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getResponse();
  }, [loading])

  const getResponse = () => {
    if (!loading && success) {
      const successMessage = message || "Successfully signed up for the events.";
      Swal.fire({
        title: "Success!",
        text: successMessage,
        icon: "success",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetEventsState());
        }
      })

      // Reset form fields after success
      setEmail("");
      setIsAccepted(false);
      setErrorEmail("");
      setErrorAcceptance("");

    } else if (!loading && error) {
      // Display the error message returned from the API
      const errorMessage = error || "This email is already subscribed for events.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetEventsState());
        }
      })

    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorEmail("");
    setErrorAcceptance("");
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      // setErrorEmail("Email is required");
      Swal.fire({
        title: "Error",
        text: "Email is required!",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    } else if (!emailPattern.test(email)) {
      Swal.fire({
        title: "Success!",
        text: "Please enter a valid email address!",
        icon: "success",
        confirmButtonText: "Ok",
      });
      // setErrorEmail("Please enter a valid email address");
      // return;
    }

    if (!isAccepted) {
      Swal.fire({
        title: "Error",
        text: "You must accept the terms and conditions!",
        icon: "error",
        confirmButtonText: "Ok",
      });
      // setErrorAcceptance("You must accept the terms");
      return;
    }
    // Dispatch the signup action
    dispatch(signupEvents({ email, is_agree: isAccepted }));

  };

  return (
    <>
      <div className="top-head-section-new"></div>
       <div className="faq-section about-us-parent">
        <div className="container event-pagecontainer">
          <div className="">
            <Head />
          </div>
          <div className="event-signupbox">
            <div className="container community-header-hurry-up event-page-section ">
              <h2>Know about all the latest LFCoin events!</h2>
            </div>
            <div className="home-container home-page centercontainer ">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="laker-fan-coin-form event-lakerform">
                  <form onSubmit={handleSubmit}>
                    <h3>Sign Up below to know about all the latest LFCoin events.</h3>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-box">
                          <label htmlFor="email">
                            Email<span className="color-asterisk">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setErrorEmail("");
                            }}
                            maxLength={40}
                          />
                          <span className="fa-solid fa-envelope field-icon"></span>
                        </div>
                        {errorEmail && (
                          <div className="validation-mess">
                            <p className="text-danger">{errorEmail}</p>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="accept-content">
                          <div className="accept-checkbox">
                            <input
                              type="checkbox"
                              id="acceptance"
                              checked={isAccepted}
                              onChange={(e) => {
                                setIsAccepted(e.target.checked);
                                setErrorAcceptance("");
                              }}
                            />
                          </div>
                          <div>
                            <label htmlFor="acceptance">
                              By joining the LFCoin Community, you agree that $LAL
                              coins are promotional and not linked to any other
                              offers or obligations. They hold no guaranteed value,
                              and $LAL is not liable for any losses or issues
                              arising from receiving or using the coins. No legal
                              claims or recourse will be accepted.
                            </label>
                          </div>
                        </div>
                        {errorAcceptance && (
                          <div className="validation-mess">
                            <p className="text-danger">{errorAcceptance}</p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="cstm-login-btn">
                      <button
                        type="submit"
                        className="btn w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 disclouser-sec">
              <div className="lend-cont-inner-in">
                <p>
                  <strong>Disclosure:</strong> LF Coin ($LAL) is a
                  community-driven meme coin created to celebrate sports fandom
                  and foster community engagement. LF Coin is not affiliated
                  with the Los Angeles Lakers, the National Basketball
                  Association (NBA), or any associated organizations. The
                  project operates independently and is solely focused on
                  building a decentralized community of sports enthusiasts. As a
                  meme coin, LF Coin carries no intrinsic value and should not
                  be considered an investment or security.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="about-footer updated-footer">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Events;